export default "__VITE_ASSET__Dfo3O_b4__"